import { StoreState } from '../store-interfaces';

export const selectInstagramAccounts = (state: StoreState) =>
  state.instagram.instagramAccounts;

export const selectInstagramAccountId = (
  state: StoreState,
): string | undefined => state.instagram.instagramAccounts[0]?.instagramId;

export const selectInstagramListMedia = (state: StoreState) =>
  state.instagram.instagramListMedia;

export const selectInstagramListMediaPaging = (state: StoreState) =>
  state.instagram.instagramListMediaPaging;

export const selectInstagramMedia = (state: StoreState) =>
  state.instagram.instagramMedia;
